module.exports = __webpack_public_path__ + "static/img/（环卫车-B域控制器）.4cb6598.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/model/type-1/（环卫车-B域控制器）.png
// module id = scYb
// module chunks = 0